export const NORTH = 'NORTH';
export const EAST = 'EAST';
export const SOUTH = 'SOUTH';
export const WEST = 'WEST';
export const FACING_DIRECTIONS = [NORTH, EAST, SOUTH, WEST];
export const MATRIX_PADDING = 5;
export const MATRIX_OFFSET = 10;
export const MATRIX_TILE_SIZE = 64;

export const LEFT_KEY = 37;
export const UP_KEY = 38;
export const RIGHT_KEY = 39;
export const DOWN_KEY = 40;



// WEBPACK FOOTER //
// ./src/app/constants/Turtle.js